export default {
    header: "U bent succesvol uitgelogd",
    message: ""
}